// FF-1129 (Analytics Outbound v1 — app GA4 light, ZEE port)
//
// AppAnalyticsInit — a tiny React component that:
//  1. Resolves Clerk userId / orgId from hooks (passed to analytics instance
//     but NOT sent to the server — the backend derives them from the token).
//  2. Creates the analytics instance.
//  3. Fires a GA4 page_view on mount (once, after Clerk is loaded).
//
// Mount this once at the app root (inside ClerkProvider), sibling to the route
// tree.  It renders null — no UI, no subtree.
//
// No VITE_GA4_* env vars are needed: the GA4 creds live in ff-backend.
// The endpoint is always /v1/app-analytics/event (relative to VITE_API_URL).

import { useAuth, useOrganization } from '@clerk/clerk-react';
import { useEffect } from 'react';

import { createAppAnalytics } from './app-analytics';

const AppAnalyticsInit = () => {
  const { userId, isLoaded: authLoaded } = useAuth();
  const { organization, isLoaded: orgLoaded } = useOrganization();
  const orgId = organization?.id ?? null;

  useEffect(() => {
    // Wait until Clerk has resolved auth + org.  Otherwise the effect fires
    // once pre-auth (anonymous) and again post-auth — a duplicate page_view.
    // Gate on both loaded flags so we emit exactly one.
    if (!authLoaded || !orgLoaded) return;

    const analytics = createAppAnalytics(
      {}, // no GA4 creds client-side; server holds them
      { userId: userId ?? null, orgId }
    );

    analytics.sendEvent('page_view', {});
  }, [authLoaded, orgLoaded, userId, orgId]);

  return null;
};

export default AppAnalyticsInit;
